import { MessageCircle } from "lucide-react";
import { useSettings } from "@/contexts/SettingsContext";

export default function WhatsAppButton() {
  const settings = useSettings();
  const message = encodeURIComponent("مرحبًا، أرغب بالاستفسار عن خدماتكم");

  return (
    <a
      href={`https://wa.me/${settings.whatsapp}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 left-6 z-50 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform animate-pulse-glow"
      data-testid="whatsapp-button"
      style={{ boxShadow: "0 0 20px rgba(37, 211, 102, 0.4)" }}
    >
      <MessageCircle size={26} className="text-white" />
    </a>
  );
}
